/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core'
import { UsuarioCandidato } from 'src/app/models/usuario-candidato'
import { UsuarioCandidatoService } from 'src/app/services/usuario-candidato.service'
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { fromEvent, debounceTime, distinctUntilChanged, tap } from 'rxjs'
import { filter } from 'rxjs/operators'
import { SearchInputComponent, DefaultPaginatorComponent } from 'src/app/modules/shared'

@Component({
  selector: 'app-lista-usuario-candidato',
  templateUrl: './lista-usuario-candidato.component.html',
  styleUrls: ['./lista-usuario-candidato.component.css'],
})
export class ListaUsuarioCandidatoComponent implements AfterViewInit, OnInit {
  @ViewChild('paginator') paginator!: DefaultPaginatorComponent
  @ViewChild(MatSort) sort!: MatSort
  @ViewChild('searchInput') searchInput!: SearchInputComponent
  totalElements: number = 0
  sortField = 'email'
  sortDirection = 'asc'

  colunasGrid: string[] = ['id', 'email', 'action']
  dataSource: MatTableDataSource<UsuarioCandidato> = new MatTableDataSource()

  constructor(private usuarioCandidatoService: UsuarioCandidatoService) {}

  ngOnInit(): void {
    // getData será chamado no ngAfterViewInit
  }

  ngAfterViewInit() {
    // server-side search
    fromEvent<KeyboardEvent>(this.searchInput.inputRef.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        filter((e: KeyboardEvent) => e.keyCode === 13),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0
          this.getData()
        })
      )
      .subscribe()

    // on sort change, reset to first page and reload
    this.sort.sortChange.subscribe(() => {
      this.sortField = this.sort.active
      this.sortDirection = this.sort.direction || 'asc'
      this.paginator.pageIndex = 0
      this.getData()
    })

    // on paginate events, load a new page
    this.paginator?.page.pipe(tap(() => this.getData())).subscribe()

    // Carrega dados iniciais
    setTimeout(() => this.getData(), 0)
  }

  private getData() {
    this.usuarioCandidatoService
      .listar(this.searchInput?.value, this.paginator.pageIndex, this.paginator.pageSize, this.sortField, this.sortDirection)
      .subscribe(data => {
        this.dataSource = new MatTableDataSource(data['content'])
        this.totalElements = data['totalElements']
      })
  }
}
